let dragPreviewRoot = null;
export function getDragPreviewRoot() {
  // NOTE: this div will exist for all tests and will only be created once per environment.
  if (dragPreviewRoot === null) {
    const root = document.createElement('div');
    root.style.position = 'fixed';
    root.style.pointerEvents = 'none';
    root.style.top = '0';
    root.style.left = '0';
    root.style.width = '100%';
    root.style.height = '100%';
    root.style.zIndex = '100';
    document.body.appendChild(root);
    dragPreviewRoot = root;
  }
  return dragPreviewRoot;
}
//# sourceMappingURL=get-drag-preview-root.js.map